import {
	useDeleteSegmentationOverrideMutation,
	useGetSegmentationOverrideQuery,
	useSetSegmentationOverrideMutation
} from "redux/apis";
import { Container, ErrorMessage, LoadingMessage } from "./styles";
import { Button } from "@mui/material";
import {
	useState,
	useEffect,
	useLayoutEffect,
	useContext,
	useRef
} from "react";
import { offersApi } from "redux/apis";
import { useDispatch } from "react-redux";
import { WebStoreContext } from "contexts/WebStoreProvider";

interface SegmentationOverrideProps {
	onSave: () => void;
	onClose: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const omitEmptyObjectProps = (obj: Record<string, any>) =>
	Object.fromEntries(
		Object.entries(obj).filter(
			([key, value]) =>
				key !== "userId" &&
				!(
					typeof value === "object" &&
					value !== null &&
					!Array.isArray(value) &&
					Object.keys(value).length === 0
				)
		)
	);

const SegmentationOverride = ({
	onSave,
	onClose
}: SegmentationOverrideProps) => {
	const [values, setValues] = useState("");
	const txtAreaRef = useRef<HTMLTextAreaElement>(null);
	const dispatch = useDispatch();
	const { userTracker, syncUserTracker } = useContext(WebStoreContext);
	const userSegmentationDataOverride = userTracker?.userSegmentationDataOverride
		? JSON.stringify(
				omitEmptyObjectProps(userTracker.userSegmentationDataOverride),
				null,
				4
		  )
		: "";
	/* eslint-disable-next-line */
	const [errorMessage, setErrorMessage] = useState<any>();
	const {
		isLoading: queryIsLoading,
		error: queryError,
		data
	} = useGetSegmentationOverrideQuery("", { refetchOnFocus: true });
	const [
		createSegmentation,
		{ isLoading: createIsLoading, error: createError }
	] = useSetSegmentationOverrideMutation();

	const [
		deleteSegmentation,
		{ isLoading: deleteIsLoading, error: deleteError }
	] = useDeleteSegmentationOverrideMutation();

	const invalidateOffersTags = () => {
		dispatch(offersApi.util.invalidateTags(["offersTag"]));
	};

	const handleSave = async () => {
		setErrorMessage("");
		// prevent CRLF injection override
		const formatedValues = values.replace(/\r?\n|\r/g, "");
		const data = await createSegmentation(formatedValues).unwrap();
		syncValues(data.userSegmentationData);
		invalidateOffersTags();
		await syncUserTracker();
		onSave();
	};

	const handleDelete = async () => {
		setErrorMessage("");
		await deleteSegmentation("").unwrap();
		invalidateOffersTags();
		await syncUserTracker();
	};
	/* eslint-disable */
	const syncValues = (data: any) => {
		const sortedData = {} as any;
		if (data) {
			Object.keys(data)
				.sort()
				.forEach(function (key) {
					sortedData[key] = data[key];
				});
		}

		setValues(data ? JSON.stringify(sortedData, null, 4) : "");
	};
	/* eslint-enable */

	useEffect(() => {
		if (data) {
			syncValues(data.data);
		}
	}, [data]);

	useLayoutEffect(() => {
		const textArea = txtAreaRef.current;
		if (textArea) {
			textArea.style.height = "auto";
			textArea.style.height = `${textArea.scrollHeight}px`;
		}
	}, [values]);

	useEffect(() => {
		if (createError) {
			setErrorMessage(
				"status" in createError
					? "error" in createError
						? createError.error
						: createError.status
					: createError.message
			);
		}
	}, [createError]);

	useEffect(() => {
		if (deleteError) {
			setErrorMessage(
				"status" in deleteError
					? "error" in deleteError
						? deleteError.error
						: deleteError.status
					: deleteError.message
			);
		}
	}, [deleteError]);

	if (queryIsLoading) {
		return <LoadingMessage>Loading Segmentation Override...</LoadingMessage>;
	}

	if (queryError) {
		return (
			<ErrorMessage>
				Error:
				{"status" in queryError
					? "error" in queryError
						? queryError.error
						: queryError.status
					: queryError.message}
			</ErrorMessage>
		);
	}

	return (
		<Container>
			<h2>Segmentation Data w Override</h2>
			<textarea
				id="txtArea"
				name="txtArea"
				ref={txtAreaRef}
				style={{ width: "700px", overflow: "hidden", resize: "none" }}
				//defaultValue={JSON.stringify(data, null, 4)}
				value={values}
				onChange={(e) => setValues(e.target.value)}
			></textarea>
			<h2>Segmentation Data Override</h2>
			<textarea
				id="userSegmentationDataOverrideTxtArea"
				name="userSegmentationDataOverrideTxtArea"
				rows={10}
				style={{ width: "700px" }}
				value={userSegmentationDataOverride}
				readOnly
			></textarea>
			{errorMessage && <ErrorMessage>Error: {errorMessage}</ErrorMessage>}
			<div>
				<Button
					variant="outlined"
					sx={{ margin: "10px" }}
					onClick={handleDelete}
					disabled={deleteIsLoading}
				>
					Clear Override
				</Button>
				<Button
					variant="outlined"
					sx={{ margin: "10px" }}
					onClick={handleSave}
					disabled={createIsLoading}
				>
					Set Override
				</Button>
				<Button variant="outlined" sx={{ margin: "10px" }} onClick={onClose}>
					Close
				</Button>
			</div>
		</Container>
	);
};

export default SegmentationOverride;
